let Void = function() {	
	return this.InvoicesList.filter((r) => r.status === 4);
};
export default Void;
